<p-dialog [(visible)]="display" class="link-details" [style]="{'width': '1000px'}">
  <p-header>
    <span>Link Details</span>
  </p-header>

  <p-table [value]="linkMembers" [scrollable]="true" scrollHeight="500px" [resizableColumns]="true">

    <ng-template pTemplate="header">
      <tr>
        @for (col of cols; track col) {
          <th pResizableColumn>{{col.header}}</th>
        }
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowData>
      <tr>
        @for (col of cols; track col) {
          <td class="{{ getMonStateStyle(rowData[col.stateField]) }}">
            <span class="uv-table-value">{{ rowData[col.field] }}</span>
          </td>
        }
      </tr>
    </ng-template>
  </p-table>

  <p-footer>
    <button type="button" pButton icon="fa fa-times" (click)="hide()" label="Close"></button>
  </p-footer>

</p-dialog>
